import React from 'react';
import PopularLocationListingItem from './PopularLocationListingItem';
import { findMarketByCity, marketPath } from '../seo/markets.mjs';
import { stateAbbr } from './location/profile/LocationProfileSEO';
import { parseLatLngParams } from '../util/AddressUtils';

interface CityObj {
    id: string;
    city: string;
    /** The full state name ("California"), from the getCities API. */
    state?: string;
    rank: number;
    imageUrl: string;
    coordinates?: string;
}

interface SearchRedirectPopularLocationListingItemProps {
    cityObj: CityObj;
}

/**
 * A card's link (securspace-ui#3055): a market's page (/yards/us/ca/los-angeles), or
 * the city's area on the map (/yards?lat&lng) when it isn't a market. No geocoding:
 * each card used to reverse-geocode its coordinates (12 billed calls per homepage
 * view), which also produced city=KCMO links.
 */
export const popularLocationLink = ({ city, state, coordinates }: Pick<CityObj, 'city' | 'state' | 'coordinates'>): string => {
    const market = findMarketByCity(city, stateAbbr(state));
    if (market) return marketPath(market);
    const [lat, lng] = (coordinates ?? '').split(',').map((part) => part.trim());
    return parseLatLngParams({ lat, lng }) ? `/yards?lat=${lat}&lng=${lng}` : '/yards';
};

const SearchRedirectPopularLocationListingItem = (props: SearchRedirectPopularLocationListingItemProps) =>
    <PopularLocationListingItem cityObj={props.cityObj} linkTo={popularLocationLink(props.cityObj)} />;

export default SearchRedirectPopularLocationListingItem;
